/**
 * Calculates the discount percentage given the original and new price.
 * Returns 0 if prices are invalid or the new price is not lower than the original price.
 *
 * @param {number} originalPrice - The original price.
 * @param {number} newPrice - The discounted price.
 * @returns {number} - The discount percentage (0-100).
 */
export const getDiscountPercentage = (originalPrice, newPrice) => {
  // Validate inputs
  const isValidPrice = (price) => typeof price === 'number' && price > 0

  if (!isValidPrice(originalPrice) || !isValidPrice(newPrice) || newPrice >= originalPrice) {
    return 0 // Return 0 for invalid inputs or if no discount applies
  }

  // Calculate discount percentage
  const discount = ((originalPrice - newPrice) / originalPrice) * 100

  // Round to 2 decimal places and return
  return Math.round(discount * 100) / 100
}
